<!--分享-->
<template>
  <div class="share">
    <van-popup round v-model="sharePop">
      <img
        class="share-img"
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/shareH5.png"
        alt=""
      />
      <p class="tips">长按上方图片，保存到相册，分享给朋友</p>
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      sharePop: false,
      prizeList: [
        { time: '2024.10.19 12:00:22', name: '一等奖' },
        { time: '2024.10.19 12:00:22', name: '一等奖' },
        { time: '2024.10.19 12:00:22', name: '一等奖' },
        { time: '2024.10.19 12:00:22', name: '一等奖' },
        { time: '2024.10.19 12:00:22', name: '一等奖' },
      ],
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.share {
  .share-img {
    display: block;
    width: 600px;
    height: 944px;
    margin: 0 auto;
  }
  .tips {
    text-align: center;
    font-weight: 500;
    font-size: 30px;
    color: #ffffff;
    margin-top: 40px;
  }
  ::v-deep{
    .van-popup {
    background-color: transparent !important;
  }
  .van-popup--center{
      top:47%;
    }
  } 
}
</style>
